import { render } from "./dialogs-select.component.vue?vue&type=template&id=17b9be60&scoped=true"
import script from "./dialogs-select.component.vue?vue&type=script&lang=js"
export * from "./dialogs-select.component.vue?vue&type=script&lang=js"

import "./dialogs-select.component.vue?vue&type=style&index=0&id=17b9be60&scoped=true&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b9be60"]])

export default __exports__